// `Math.DEG_PER_RAD` constant
// https://rwaldron.github.io/proposal-math-extensions/
require('../internals/export')({ target: 'Math', stat: true }, { DEG_PER_RAD: Math.PI / 180 });
